var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    id: "idea",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    fill: "#60c5b8",
    d: "M14.357 1022.362a.41.41 0 0 0-.41.411v2.3a9.036 9.036 0 0 0-2.712 1.119l-1.624-1.624a.41.41 0 0 0-.58 0l-2.325 2.325a.41.41 0 0 0 0 .58l1.627 1.627a9.036 9.036 0 0 0-1.123 2.709h-2.3a.41.41 0 0 0-.41.41v3.286c0 .228.183.41.41.41h2.301a9.036 9.036 0 0 0 1.119 2.712l-1.624 1.624a.41.41 0 0 0 0 .58l2.325 2.325c.16.161.42.161.58 0l1.627-1.627a9.036 9.036 0 0 0 2.708 1.123v2.3c0 .227.184.41.411.41h3.286a.41.41 0 0 0 .41-.41v-2.301a9.036 9.036 0 0 0 2.712-1.118l1.624 1.623c.16.161.42.161.58 0l2.325-2.325a.41.41 0 0 0 0-.58l-1.627-1.627a9.036 9.036 0 0 0 1.123-2.708h2.3a.41.41 0 0 0 .41-.411v-3.286a.41.41 0 0 0-.41-.41h-2.301a9.036 9.036 0 0 0-1.119-2.712l1.624-1.623a.41.41 0 0 0 0-.581l-2.325-2.325a.41.41 0 0 0-.58 0l-1.627 1.627a9.036 9.036 0 0 0-2.708-1.123v-2.299a.41.41 0 0 0-.411-.41h-3.286z",
    color: "#000",
    overflow: "visible",
    transform: "translate(0 -1019.386)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    fill: "#fcd062",
    d: "M16 1026.839a7 7 0 0 0-7 7 7 7 0 0 0 .03.6c.302 4.529 3.939 5.589 3.939 8.494h.797a.983.983 0 0 0-.766.953v4c0 .554.446 1 1 1h4c.554 0 1-.446 1-1v-4a.983.983 0 0 0-.766-.953h.797c0-2.884 3.585-3.95 3.934-8.395a7 7 0 0 0 .035-.7 7 7 0 0 0-7-7z",
    color: "#000",
    overflow: "visible",
    transform: "translate(0 -1019.863)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    fill: "#576d7e",
    d: "M13 1042.933v4.953c0 .554.446 1 1 1h4c.554 0 1-.446 1-1v-4.953z",
    color: "#000",
    overflow: "visible",
    transform: "translate(0 -1019.863)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2b4255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.508 23.523h6.984m-6.984 2h6.984m-6.984 2h6.984"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.1e52fce9f224064944844fdde980e64c.svg";
export { ForwardRef as ReactComponent };